import { apiRoutes } from './dirs/api.js';
import { appRoutes } from './dirs/app.js';
import { consoleRoutes } from './dirs/console.js';
import { constants } from './dirs/constants.js';
import { crosswordRoutes } from './dirs/crosswords.js';
import { helpRoutes } from './dirs/help.js';
import { scRoutes } from './dirs/sc.js';
import { settingsRoutes } from './dirs/settings.js';
import { showsRoutes } from './dirs/shows.js';
export const rootRoutes = {
    home: {
        main: {
            route: '/',
            get: () => '/',
        },
    },
    constants,
    api: apiRoutes,
    app: appRoutes,
    crosswords: crosswordRoutes,
    sc: scRoutes,
    help: helpRoutes,
    shows: showsRoutes,
    console: consoleRoutes,
    settings: settingsRoutes,
    facebookUrl: {
        main: {
            route: `https://www.facebook.com/:facebook_user_name`,
            get: (facebook_user_name) => `https://www.facebook.com/${facebook_user_name}`,
        },
    },
    twitterUrl: {
        main: {
            route: `https://twitter.com/:twitter_user_name`,
            get: (twitter_user_name) => `https://www.twitter.com/${twitter_user_name}`,
        },
    },
};
//# sourceMappingURL=index.js.map